import { supabase } from "@/integrations/supabase/client";
import { getDeviceId } from "@/utils/device";
import OfflineLogger from "@/utils/offlineLogger";

export interface PendingSyncCommand {
  id: string;
  userId: string;
  deviceId: string;
  command: string;
  payload: Record<string, unknown> | null;
  createdAt: string;
  processedAt: string | null;
}

interface PendingSyncCommandRow {
  id: string;
  user_id: string;
  device_id: string;
  command: string;
  payload: Record<string, unknown> | null;
  created_at: string;
  processed_at: string | null;
}

class SyncCommandsService {
  async fetchPendingCommands(userId: string): Promise<PendingSyncCommand[]> {
    const deviceId = getDeviceId();

    try {
      const { data, error } = await supabase
        .from("sync_commands")
        .select("id, user_id, device_id, command, payload, created_at, processed_at")
        .eq("user_id", userId)
        .eq("device_id", deviceId)
        .is("processed_at", null)
        .order("created_at", { ascending: true });

      if (error) {
        throw error;
      }

      const rows = (data as PendingSyncCommandRow[] | null) ?? [];

      return rows.map((row) => ({
        id: row.id,
        userId: row.user_id,
        deviceId: row.device_id,
        command: row.command,
        payload: row.payload,
        createdAt: row.created_at,
        processedAt: row.processed_at,
      }));
    } catch (error) {
      OfflineLogger.error("SyncCommandsService.fetchPendingCommands", error);
      return [];
    }
  }
}

export const syncCommandsService = new SyncCommandsService();
